import { getTextNodes } from './getTextNodes';
import { processTokensInNode } from './processTokensInNode';

export const processTokensInDocument = (doc: Document) =>
  getTextNodes(doc.body).forEach(processTokensInNode);
